<template>
  <div class="flex items-center gap-2 sm:gap-5">
    <UAvatar :ui="{root: 'w-10 h-10 sm:w-12 sm:h-12 bg-primary', fallback: '!text-inverted'}" alt="Mattias Kieler" size="xl" />
    <div>
      <h1 class="text-sm sm:text-lg font-bold">Mattias Kieler</h1>
      <p class="text-xs sm:text-sm text-gray-500">Fullstack-udvikler</p>
    </div>
  </div>
</template>
